import mongoose, { Model, Schema } from "mongoose";
import { RatingDocument } from "../interfaces/rating.interface";

const RatingSchema = new Schema<RatingDocument>({
    userId: { type: Schema.Types.ObjectId, ref: 'User', required: true },
    raterId: { type: Schema.Types.ObjectId, ref: 'User', required: true },
    rating: { type: Number, min: 1, max: 5, required: true },
    feedback: { type: String, trim: true, maxlength: 500, required: false },
    createdAt: { type: Date, default: Date.now },
    isDeleted: { type: Boolean, default: false },
    deletedAt: { type: Date, default: null },
    updatedAt: { type: Date }
}, { timestamps: true, versionKey: false });

const Rating: Model<RatingDocument> = mongoose.model<RatingDocument>('Rating', RatingSchema)
export default Rating